import Image from 'next/image';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import devices from '@/utilities/devices';

const BackgroundImageContainer = styled.div`
	background: ${props => props.url ? `url(${props.url})` : props.theme.color.transparent};
	position: relative;
	width:100%;
	height: 100%;
	background-size: ${props => props.imageSize};
	background-repeat: no-repeat;
	background-position: center;
	background-color: ${props => {
		switch (props.bgColor) {
			case 'red':
				return props.theme.color.red;
			case 'beige':
				return props.theme.color.beige;
			case 'blue':
				return props.theme.color.blue;
			case 'prune':
				return props.theme.color.prune;
			case 'white':
				return props.theme.color.white;
			default: props.theme.color.transparent;
		}
	}};

	> div {
		img {
			width: ${props => props.imageSize} !important;
			min-width: ${props => props.imageSize} !important;
			max-width: ${props => props.imageSize} !important;
			height: ${props => props.imageSize} !important;
			min-height: ${props => props.imageSize} !important;
			max-height: ${props => props.imageSize} !important;
		}
	}

	@media screen and (${devices.mobile}) {
		display: ${props => props.hideOnMobile ? 'none' : 'block'};
		width: ${props => props.hideOnMobile ? '0' : '100%'};
		height: ${props => props.hideOnMobile ? '0' : '100%'};
		background: ${props => props.hideOnMobile && 'none'};
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		display: ${props => props.hideOnMobile ? 'none' : 'block'};
		width: ${props => props.hideOnMobile ? '0' : '100%'};
		height: ${props => props.hideOnMobile ? '0' : '100%'};
		background: ${props => props.hideOnMobile && 'none'};
	}
`;

const BackgroundImage = ({ className, children, url, imageSize, hideOnMobile, bgColor, quality, unoptimized }) => {
	return (
		<BackgroundImageContainer
			className={className}
			url={unoptimized && url}
			imageSize={imageSize}
			hideOnMobile={hideOnMobile}
			bgColor={bgColor}
		>
			{!unoptimized && (
				<Image
					src={url}
					alt="aside image"
					fill
					style={{ objectFit: imageSize ? 'contain' : 'cover' }}
					priority={false}
					quality={quality ?? 80}
					unoptimized={unoptimized ?? true}
				/>
			)}
			{children}
		</BackgroundImageContainer>
	);
};

BackgroundImage.propTypes = {
	children: PropTypes.element,
	className: PropTypes.string,
	url: PropTypes.any,
	imageSize: PropTypes.string,
	hideOnMobile: PropTypes.bool,
	bgColor: PropTypes.oneOf(['red', 'beige', 'blue', 'prune', 'white']),
	quality: PropTypes.number,
	unoptimized: PropTypes.bool,
};

export default BackgroundImage;
